import axios from "axios";
import {
    getPlansURL,
    OUTBOUND,
    INBOUND,
    DOMAIN_RANGE_LIMIT,
    planDetails,
    TRANSACTIONAL_API,
} from "../utils/constants";
import {
    fetchAllPlansStart,
    fetchAllPlansSuccess,
    fetchAllPlansError,
} from "../actions/plansActions";
import { getEmailLimit, friendlyPrice, numericalUnitsFromProductUnit } from "../utils/calculators";

const inboundTransform = inboundPlan => {
    const { name, handle, basePrice, features } = inboundPlan;
    let filteredPrices = [];
    let prices = features[0]["pricing"]["prices"];

    /**
     * We want to set a limit on pricing slider no matter what the inbound plan's price points are
     * To do that, the inbound plan pricing will be filtered by the domain limit we set (DOMAIN_RANGE_LIMIT),
     * any price points that has a higher upperBound than DOMAIN_RANGE_LIMIT will be replaced with DOMAIN_RANGE_LIMIT.
     */
    for (let i = 0; i < prices.length; i++) {
        const { pricePerUnit, upperBound, lowerBound } = prices[i];
        if (DOMAIN_RANGE_LIMIT > upperBound) {
            filteredPrices.push({
                ...prices[i],
            });
        } else {
            filteredPrices.push({
                pricePerUnit,
                lowerBound,
                upperBound: DOMAIN_RANGE_LIMIT,
            });
            break; //the price points are ascending order, so we can skip the rest
        }
    }
    features[0]["pricing"]["prices"] = filteredPrices;
    return {
        planName: name,
        planHandle: handle,
        features: features,
        basePrice: basePrice,
        displayUnit: "domains",
        descriptions: ["Intelligent Quarantine™", "Web console dashboard"],
    };
};

const outboundTransform = outboundPlan => {
    const { name, handle, basePrice, features, overageSupport } = outboundPlan;
    const overageRate = features[0].pricing.prices[0].pricePerUnit;
    const unitName = features[0].unitName;
    const unit = numericalUnitsFromProductUnit(unitName);
    return {
        planName: name,
        planHandle: handle,
        includedEmails: getEmailLimit(outboundPlan),
        features: features,
        basePrice: basePrice,
        overageRate: overageRate,
        unitName: unitName,
        unit: unit,
        displayUnit: "emails",
        descriptions: [
            `${friendlyPrice(overageRate)} per 1,000 extra emails`,
            "Unlimited outbound domains",
            "Filtering for 5 inbound domains included",
        ],
        planDetails: planDetails[name],
        overageSupport: overageSupport,
    };
};

const transactionalTransform = txPlan => {
    const { name, handle, basePrice } = txPlan;
    return {
        planName: name,
        planHandle: handle,
        basePrice: basePrice,
        descriptions: [
            `Email API`,
        ],
    };
};

const planShapeTransform = rawData => {
    const inbound = rawData[INBOUND];
    const outbound = rawData[OUTBOUND];
    const transactional = rawData[TRANSACTIONAL_API];

    let data = {
        //transform inbound
        [INBOUND]: inbound.map((plan, index) => ({ key: index, ...inboundTransform(plan) })),
        //transform outbound
        [OUTBOUND]: outbound.map((plan, index) => ({ key: index, ...outboundTransform(plan) })),
        //transform transactional
        [TRANSACTIONAL_API]: transactional.map((plan, index) => ({ key: index, ...transactionalTransform(plan) })),
    };

    return data;
};

const fetchAllPlans = async dispatch => {
    dispatch(fetchAllPlansStart());
    try {
        const result = await axios(getPlansURL);
        const plans = planShapeTransform(result.data);
        dispatch(fetchAllPlansSuccess(plans));
    } catch (error) {
        console.log({ error });
        dispatch(fetchAllPlansError(error));
    }
};

export { fetchAllPlans, inboundTransform, outboundTransform, transactionalTransform };
